import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/illustration-questions.svg';
import { color, font } from 'src/shared/styles/variables';

export const StyledQuestionsList = styled('ol')({
    padding: '1rem',
});

export const StyledQuestion = styled('li')(
    {
        marginBottom: '1.5rem',
        color: color.blueLagoon,
    },
    font.medium(font.size.medium),
);

export const SettingGoalsStep = withTranslation('cbt')(({ t }: WithTranslation) => {
    const descriptions: string[] = t('week-2.setting-goals.descriptions', { returnObjects: true });
    const questions: string[] = t('week-2.setting-goals.questionsList', { returnObjects: true });

    return (
        <>
            <S.ContentRow>
                <S.ContentColumn>
                    <S.StepHeading>{t('week-2.setting-goals.title')}</S.StepHeading>
                </S.ContentColumn>
            </S.ContentRow>
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    {descriptions.map((description: string) => (
                        <S.StepDescription key={description} small>
                            {description}
                        </S.StepDescription>
                    ))}
                    <StyledQuestionsList>
                        {questions.map((question: string) => (
                            <StyledQuestion key={question}>{question}</StyledQuestion>
                        ))}
                    </StyledQuestionsList>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
        </>
    );
});
